import { useTranslation } from 'react-i18next';
import { GlobeAltIcon } from '@heroicons/react/24/outline';
import { useEffect } from 'react';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Set document direction based on language
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-white/30 bg-white/10 hover:bg-white/20 backdrop-blur-sm transition-colors text-sm font-medium text-white shadow-sm"
      aria-label="Switch language"
    >
      <GlobeAltIcon className="w-5 h-5" />
      <span className="font-semibold">{i18n.language === 'en' ? 'العربية' : 'English'}</span>
    </button>
  );
}
